import { useClient } from './useClient';

import type { IArea } from 'models';

export const useGetRegions = () => useClient<IArea[]>({ url: `api/regions/expanded/` });
